import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai"; // Import icons
import "../scss/login.scss";

const Login = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState({});
  const [errorValue, setErrorValue] = useState(false);
  const [showPassword, setShowPassword] = useState(false); // New state for password visibility
  const navigate = useNavigate();
  const url = process.env.REACT_APP_BASE_URL;

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(`${url}/login`, { username, password });
      const token = response.data.token;
      const type = response.data.type;
      const userID = response.data.user_id;

      sessionStorage.setItem("token", token);
      sessionStorage.setItem("user", username);
      sessionStorage.setItem("type", type);
      sessionStorage.setItem("userID", userID);

      if (token && type !== "kitchen") {
        navigate("/bill");
      } else {
        navigate("/home");
      }
    } catch (error) {
      setError(error.response?.data || {});
      setErrorValue(true);
    }
  };

  useEffect(() => {
    if (sessionStorage.getItem("token")) {
      navigate("/bill");
    }
  }, [navigate]);

  return (
    <div className="bg-login">
      <div className="bg-form-img"></div>
      <form className="p-8 rounded shadow-md w-full max-w-md">
        <div className="img-logo">
          <img src="./logo.jpg" alt="logo" className="logo" />
        </div>

        <label className="block mb-1">Username</label>
        <input
          type="text"
          placeholder="Email or Phone"
          id="username"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          className="username"
        />

        <label className="block mb-1">Password</label>
        <div className="relative mb-4">
          <input
            type={showPassword ? "text" : "password"}
            placeholder="Password"
            id="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="password"
          />
          <span
            className="absolute right-3 top-4 cursor-pointer text-gray-600"
            onClick={() => setShowPassword(!showPassword)}
          >
            {showPassword ? <AiOutlineEyeInvisible size={20} /> : <AiOutlineEye size={20} />}
          </span>
        </div>

        <button
          className="btn-login"
          onClick={handleLogin}
        >
          Log In
        </button>

        {errorValue && <p className="error">{error.error}</p>}
      </form>
    </div>
  );
};

export default Login;
